export async function loadSizeUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("size", async () => {
        const { SizeUpdater } = await import("./SizeUpdater.js");
        return new SizeUpdater();
    }, refresh);
}
